"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picture = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importDefault(require("react"));

var Picture = function Picture(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b,
      className = _a.className,
      src = _a.src,
      srcSets = _a.srcSets;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Picture',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement("picture", {
    className: rootClasses,
    "data-testid": testID
  }, srcSets && srcSets.map(function (_a) {
    var srcSet = _a.srcSet,
        media = _a.media,
        sizes = _a.sizes,
        type = _a.type;
    return react_1.default.createElement("source", {
      key: srcSet,
      srcSet: srcSet,
      media: media,
      sizes: sizes,
      type: type
    });
  }), react_1.default.createElement("img", {
    src: src,
    className: className,
    alt: alt
  }));
};

var PictureWithSpace = (0, ui_helper_with_space_1.withSpace)(Picture);
exports.Picture = PictureWithSpace;